import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import snackbar from "./snackbar.module";
import misc from "./misc.module";
import dictionary from "./dictionary.module";
import user from "./user.module";
import vehicle from "./vehicle.module";
import faultMessage from "./faultMessage.module";
import fleet from "./fleet.module";
import issue from "./issue.module";
import component from "./dictionary/component.module";
import serviceReport from "./serviceReport.module";
import reviewReport from "./reviewReport.module";
import report from "./report.module";
import dashboard from "./dashboard.module";
import coefficientReadiness from "./coefficient/readiness.module";
import coefficientReliability from "./coefficient/reliability.module";
import sparePartType from "./dictionary/sparePartType.module";
import sparePart from "./dictionary/sparePart.module";
import vehicleSpareParts from "./vehicleSpareParts.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    snackbar,
    misc,
    dictionary,
    user,
    vehicle,
    faultMessage,
    fleet,
    issue,
    component,
    serviceReport,
    reviewReport,
    report,
    dashboard,
    coefficientReadiness,
    coefficientReliability,
    sparePartType,
    sparePart,
    vehicleSpareParts
  }
});
